function t(t,e){return t===e||t!=t&&e!=e}export{t as default};
//# sourceMappingURL=eq.js.map
